module.exports = __webpack_public_path__ + "static/media/dark-bronze.92f56319.jpg";